import logger from '../utils/logger';
import api from '../config/api';

export const orderService = {
    async getShopOrders() {
        try {
            const response = await api.get('/orders');
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to fetch shop orders:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch orders' };
        }
    },

    async getActiveOrders() {
        try {
            const response = await api.get('/orders/active');
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to fetch active orders:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch active orders' };
        }
    },

    async createOrder(orderData) {
        try {
            const response = await api.post('/orders', orderData);
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to create order:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to create order' };
        }
    },

    async updateOrderStatus(orderId, status) {
        try {
            const response = await api.put(`/orders/${orderId}/status?status=${status}`);
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to update order status:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to update order status' };
        }
    },

    async updateOrder(orderId, orderData) {
        try {
            const response = await api.put(`/orders/${orderId}`, orderData);
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to update order:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to update order' };
        }
    },

    async getOrderById(orderId) {
        try {
            const response = await api.get(`/orders/${orderId}`);
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to fetch order:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch order' };
        }
    },

    async createPublicOrder(slug, orderData) {
        try {
            const response = await api.post(`/shop/${slug}/orders`, orderData);
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to create public order:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to create order' };
        }
    }
};

export default orderService; 